<template>
	<div>
		<Header :sel='4' @changePhone="changePhone"/>
		<div :class="['cd-main-content',showPhone?'nav-is-visible':'']">
		  <!-- your content here --> 
		  <!--banner-->
		  <div class="banner"> 
		  <div class="banner_txt">
		  <p><strong>PRODUCTS </strong></p><p>产品中心</p></div></div>
		  <!--banner--> 
		  
		  <!--neirong-->
		  <div class="neirong"> 
		    <!--left-->
		    
		    
		
		<div class="bread"> <a href="javascript:void(0)" @click="goNext('/')">首页</a> - <a href="javascript:void(0)">产品与服务</a></div>
		<div class="neirong_c">
		  <ul class="jingpin_list3">
		            <li v-for="item in list"><a href="javascript:void(0);" @click="goDetail(item.id)"><img :src="item.image" /><br />
		              <strong>{{item.productName}}</strong><p>{{item.remark}}</p></a></li>
					  <div class="pick"></div>
		           
		          </ul>
		   
		      
			<ul id="page">
			    <li><a href="javascript:void(0)" @click="goPage('home')">首页</a></li>
			    <li><a href="javascript:void(0)" @click="goPage('last')">上一页</a></li>
			    <li v-for="index in indexs" @click="goPage(index)"><a :class="pagenum==index?'pagesel':''" href="javascript:void(0)">{{index}}</a></li>
			    <li><a href="javascript:void(0)" @click="goPage('next')">下一页</a></li>
			    <li><a href="javascript:void(0)" @click="goPage('end')">尾页</a></li>
			    <li class="total">共{{totalPage}}页</li>
			</ul>
			</div>

		</div>
		<Footer />
		</div>
		
		
	</div>
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import {
		infoList
	} from '@/api/reqFetch.js'
	export default {
		components: {
			Footer,
			Header,
		},
		name: '',
		layout: '',

		data() {
			return {
				list:[],
				pagenum: 1,
				indexs: [],
				totalPage: 0,
				industryList:[],
				title:'',
				showPhone:false
			}
		},

		created() {
			this.getData()
		},

		methods: {
			changePhone(val){
				this.showPhone=val
			},
			checkIndex() {
			    var left = 1;
			    var right = this.totalPage;
			    var ar = [];
			    if (this.totalPage >= 3) {
			        if (this.pagenum > 1 && this.pagenum < this.totalPage - 2) {
			            left = this.pagenum - 1
			            right = this.pagenum + 1
			        } else {
			            if (this.pagenum <= 1) {
			                left = 1
			                right = 3
			            } else {
			                right = this.totalPage
			                left = this.totalPage - 2
			            }
			        }
			    }
			    while (left <= right) {
			        ar.push(left)
			        left++
			    }
			    this.indexs = ar
			
			},
			goPage(type) {
			    if (type == 'home') {
			        this.pagenum = 1
			    } else if (type == 'end') {
			        this.pagenum = Number(this.totalPage)
			
			    } else if (type == 'last') {
			        if (this.pagenum > 1) {
			            this.pagenum = this.pagenum - 1
			        }
			    } else if (type == 'next') {
			        if (this.pagenum < (this.totalPage)) {
			            this.pagenum = this.pagenum + 1
			        }
			    } else {
			        this.pagenum = type
			    }
			    this.getData()
			},
			
			getData(){
				infoList({
					pageNum: this.pagenum,
					pagesize: 10,
				}).then(res => {
				  this.list = res.rows;
				  this.totalPage = Math.ceil(res.total / 10)
				  this.checkIndex();
				});
			},
			goDetail(id){
				this.$router.push({
					path:'/productDetail',
					query:{id:id}
				})
			},
			goNext(url){
				this.$router.push({
					path:url,
				})
			}
		}
	}
</script>

<style scoped>
	.banner{
		background-image: url('../../assets/images/banner_04.png');
	}
</style>
